import { mutationNames } from '@/store/storeKeysettings'

const state = {
  Form: {
    SubscriptionModule_Id: 0,
    PageTitle: '',
    FormFields: '',
    AlertOnNewFormSubmission: null,
    AlertEmailAddress: '',
    AlertEmailSubject: '',
    SubmitButtonLabel: '',
    SubmitSuccessMessage: '',
    SubmitErrorMessage: '',
    RowCreated: null,
    RowUpdated: null
  },
  FormData: null
}

const mutations = {
  [mutationNames.SET_FORM](state, Form) {
    state.Form = Form
  },
  [mutationNames.SET_FORMFIELDS](state, FormFields) {
    if (FormFields !== null) {
      state.Form.FormFields = FormFields
    }
  },
  [mutationNames.SET_FORMDATA](state, FormData) {
    state.FormData = FormData
  }
}

const actions = {
  setFormData: ({
    commit
  }, payload) => {
    commit(mutationNames.SET_FORM, payload)
  },
  setFormFieldsData: ({
    commit
  }, payload) => {
    commit(mutationNames.SET_FORMFIELDS, payload)
  },
  submitFrom: ({
    commit
  }, payload) => {
    commit(mutationNames.SET_FORMDATA, payload)
  }
}

const getters = {
  Form: state => {
    return state.Form
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/form.js